import { ContentStateInterface, ContentStateProperty } from '../../../../../../@types/types'
import LocationInput from '../../../../../common/inputs/locationInput/LocationInput'
import { FC, useCallback } from 'react'
import { useOnChangeV2 } from '../../../../../logic/useOnChangeV2'
import { useAppDispatch } from '../../../../../../app/hooks'
import { EntityObject } from '../../../../../../@types/geoAutocompletion-types'
import { queryGeoCodesDebounced } from '../../../../../../redux/thunks/gisService/gisService'
import { useTranslation } from 'react-i18next'
import LabelWithTooltip from '../../basicInfo/fields/common/LabelWithTooltip'
import AddressPopoverContent from '../addressPopoverContent/AddressPopoverContent'

type StreetFieldProps = {
  insertionData: {
    street?: string
  }
  validationMessages?: {
    street?: string[]
  }
  locations: EntityObject[]
  locationType?: string
}

export const StreetField: FC<StreetFieldProps> = ({ insertionData, validationMessages, locations, locationType }) => {
  const { t } = useTranslation()
  const onChangeV2 = useOnChangeV2()
  const dispatch = useAppDispatch()

  const updateAddress = useCallback(
    (propertyName: ContentStateProperty, value: string | undefined, object?: EntityObject) => {
      onChangeV2((old): ContentStateInterface => {
        return {
          ...old,
          [propertyName]: value, //TODO: make it nicer
          ...(object
            ? {
                addressId: object.id,
                street: object.address?.street,
                postcode: object.address?.postcode,
                city: object.address?.city,
                quarter: object.address?.quarter,
              }
            : {}),
        }
      })
      dispatch(queryGeoCodesDebounced())
    },
    [dispatch, onChangeV2]
  )

  const labelTooltip = (
    <LabelWithTooltip
      inputId={'street'}
      labelText={t('wizard.screen.nationalAddress.street')}
      tooltipContent={<AddressPopoverContent />}
      showMandatory={true}
      arrowPosition='left'
    />
  )

  return (
    <LocationInput
      id='street'
      propertyName='street'
      labelTooltip={labelTooltip}
      input={insertionData.street}
      style={{}}
      errors={validationMessages!.street ?? []}
      locations={locations}
      locationType={locationType}
      onChange={updateAddress}
      dataHeyimmoContext='address_street'
    />
  )
}
